import { ofType } from 'redux-observable'

import APP, { epicErrorHandler, epicResponseHandler, epicServerRequest } from 'app'

import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

export const PL_PLAYER_FETCH = 'PL_PLAYER_FETCH'
export const PL_PLAYER_FETCH_CANCELED = 'PL_PLAYER_FETCH_CANCELED'
export const PL_PLAYER_FETCH_ERROR = 'PL_PLAYER_FETCH_ERROR'
export const PL_PLAYER_FETCH_FULFILLED = 'PL_PLAYER_FETCH_FULFILLED'

export const playerFetch = (playerId) => ({
  payload: { playerId },
  type: PL_PLAYER_FETCH,
})

export const playerFetchFulfilled = (payload) => ({
  payload,
  type: PL_PLAYER_FETCH_FULFILLED,
})

export const playerFetchCanceled = (payload) => ({
  payload,
  type: PL_PLAYER_FETCH_CANCELED,
})

export const playerFetchError = (payload) => ({
  error: true,
  payload,
  type: PL_PLAYER_FETCH_ERROR,
})

export const playerFetchEpic = (action$) =>
  action$.pipe(
    ofType(PL_PLAYER_FETCH),
    mergeMap((action) =>
      epicServerRequest('get', `${APP.api_url}/users/player/${action.payload.playerId}/show`, action).pipe(
        map(epicResponseHandler(playerFetchFulfilled, action)),
        takeUntil(action$.pipe(ofType(PL_PLAYER_FETCH_CANCELED))),
        catchError(epicErrorHandler(playerFetchError, action)),
      ),
    ),
  )
